import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
  { to: "/", label: "Início", testId: "nav-link-home" },
  { to: "/sobre", label: "Sobre", testId: "nav-link-about" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 w-full"
      data-testid="site-navbar"
    >
      <div className="absolute inset-0 backdrop-blur-xl bg-white/70 border-b border-[#7c3aed]/10" />
      <nav className="relative max-w-7xl mx-auto px-5 sm:px-8 py-3.5 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="shrink-0">
          <Logo />
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              end={l.to === "/"}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-semibold transition-all ${
                  isActive
                    ? "bg-[#7c3aed]/10 text-[#6d28d9]"
                    : "text-[#3c1e6b]/70 hover:text-[#6d28d9] hover:bg-[#7c3aed]/5"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#baixar"
            data-testid="nav-download-cta"
            className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-[#6d28d9] bg-[#7c3aed]/10 hover:bg-[#7c3aed]/16 transition-all"
          >
            Baixar o app
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            className="md:hidden p-2 rounded-full text-[#5B21B6] hover:bg-[#7c3aed]/10"
            aria-label="Abrir menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </nav>

      {open && (
        <div
          className="md:hidden relative bg-white border-b border-[#7c3aed]/10 px-5 pb-5 pt-2"
          data-testid="nav-mobile-menu"
        >
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`${l.testId}-mobile`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl text-base font-semibold ${
                    isActive
                      ? "bg-[#7c3aed]/10 text-[#6d28d9]"
                      : "text-[#3c1e6b]/80 hover:bg-[#7c3aed]/5"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href="#baixar"
              onClick={() => setOpen(false)}
              data-testid="nav-download-cta-mobile"
              className="mt-2 px-5 py-3 rounded-xl text-base font-semibold text-[#6d28d9] bg-[#7c3aed]/10 text-center"
            >
              Baixar o app
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
